import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { FullUser } from "./domain/FullUser";
import { authServices } from "./services/auth.service";

export const getCurrentUser = createAsyncThunk(
  "Auth/getCurrentUser",
  async () => {
    return await authServices.getCurrentUser();
  }
);

interface mainState {
  userFetched: boolean;
  userError: boolean;
  user?: FullUser;
}

const initialState: mainState = {
  userFetched: false,
  userError: false,
  user: undefined,
};

export const mainSlice = createSlice({
  name: "carnets-main",
  initialState: initialState,
  reducers: {
    setUser: (state, action: PayloadAction<FullUser>) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrentUser.fulfilled, (state, action) => {
      state.user = action.payload;
      state.userFetched = true;
      state.userError = false;
    });
    builder.addCase(getCurrentUser.rejected, (state, action) => {
      state.userFetched = true;
      state.userError = true;
    });
  },
});

export const { setUser } = mainSlice.actions;

export const selectState = (state: RootState) => state.auth;

export default mainSlice.reducer;
